import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import placeholderImage from '../images/placeholder.jpg';
// import Gallery33 from '../images/compressed-images (3)/Gallery33.jpg';
// import Gallery34 from '../images/compressed-images (3)/Gallery34.jpg';
// import Gallery35 from '../images/compressed-images (3)/Gallery35.jpg';
// import Gallery36 from '../images/compressed-images (3)/Gallery36.jpg';
// import Gallery37 from '../images/compressed-images (3)/Gallery37.jpg';
// import Gallery38 from '../images/compressed-images (3)/Gallery38.jpg';
// import Gallery39 from '../images/compressed-images (3)/Gallery39.jpg';
// import Gallery40 from '../images/compressed-images (3)/Gallery40.jpg';
// import Gallery41 from '../images/compressed-images (3)/Gallery41.jpg';
// import Gallery42 from '../images/compressed-images (3)/Gallery42.jpg';
// import Gallery44 from '../images/compressed-images (3)/Gallery44.jpg';
// import Gallery45 from '../images/compressed-images (3)/Gallery45.jpg';
// import Gallery46 from '../images/compressed-images (3)/Gallery46.jpg';
// import Gallery47 from '../images/compressed-images (3)/Gallery47.jpg';
// import Gallery48 from '../images/compressed-images (3)/Gallery48.jpg';
import Shoulderarthroscopy from '../images/Shoulderarthroscopy.jpg'
import Shoulderarthroscopyprocedure from '../images/Shoulderarthroscopyprocedure.jpg'
import Plastercastingprocedure from '../images/Plastercastingprocedure.jpg'
import Wristarthroscopyprocedure from '../images/Wristarthroscopyprocedure.jpg'
import Shoulderarthroscopyprocedure2 from '../images/Shoulderarthroscopyprocedure-2.jpg'
import Shoulderarthroscopyprocedure3 from '../images/Shoulderarthroscopyprocedure-3.jpg'
import telanganaarthroscopysociety from '../images/Faculty-at-telangana-arthroscopy.jpg'
import hyderabadarthroscopy from '../images/hyderabad-arthroscopy-conclave-2025.jpg'
import telanganaorthopaedic from '../images/telangana-orthopaedic-surgeon-association-conference-2025.jpg'
import Tosacon2025 from '../images/TOSACON-2025.jpg'
import Germany2024 from '../images/germany-2024.jpg'
import Wristarthroscopyprocedure2 from '../images/Wristarthroscopyprocedure-2.jpg'
import WithDrlorenzomerlini from '../images/WithDrlorenzomerlini.jpg'
import WithDrahlamArnout from '../images/WithDrahlamArnout.jpg'
import Tosacon2024 from '../images/FacultyatTASCON2024.jpg'
import carpometarpal from '../images/carpometarpaljointarthroscopy.jpg'
import arthroplastyworkshop from '../images/arthroplastyworkshop.jpg'
import HandMicrosurgery from '../images/Hand&Microsurgery.jpg'
import nephewacademy from '../images/nephewacademy.jpg'
import clinicphoto from '../images/Clinicphoto.jpg'
import Opdconsultation from '../images/Opdconsultation.jpg'
import TotalKneeReplacement from '../images/Totalkneereplacement.jpg'
import OtsAudience from '../images/ots-summit-2026-audience.png'
import OtsPresentation from '../images/ots-summit-2026-presentation.png'
import OtsGroup from '../images/ots-summit-2026-group.png'
import OtsFaculty from '../images/ots-summit-2026-faculty.png'
import OtsPoster from '../images/ots-summit-2026-poster.png'
import OtsFireside from '../images/ots-summit-2026-fireside.png'
import OtsSessionFaculty from '../images/ots-summit-2026-session-faculty.png'
import HealthCamp01 from '../images/anniversary-health-camp-01.jpg'
import HealthCamp02 from '../images/anniversary-health-camp-02.jpg'
import HealthCamp03 from '../images/anniversary-health-camp-03.jpg'
import HealthCamp04 from '../images/anniversary-health-camp-04.jpg'
import HealthCamp05 from '../images/anniversary-health-camp-05.jpg'
import HealthCamp06 from '../images/anniversary-health-camp-06.jpg'
import HealthCamp07 from '../images/anniversary-health-camp-07.jpg'
import HealthCamp08 from '../images/anniversary-health-camp-08.jpg'
import HealthCamp09 from '../images/anniversary-health-camp-09.jpg'
import HealthCamp10 from '../images/anniversary-health-camp-10.jpg'
import IaseonPhoto01 from '../images/iaseon-2026-kolkata-01.jpg'
import IaseonPhoto02 from '../images/iaseon-2026-kolkata-02.jpg'
import IaseonPhoto03 from '../images/iaseon-2026-kolkata-03.jpg'
import IaseonPhoto04 from '../images/iaseon-2026-kolkata-04.jpg'
import IaseonPhoto05 from '../images/iaseon-2026-kolkata-05.jpg'
import IaseonPhoto06 from '../images/iaseon-2026-kolkata-06.jpg'
import IaseonPhoto07 from '../images/iaseon-2026-kolkata-07.jpg'
import SEO from './SEO';


export default function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState(null);
  const summitGalleryRef = useRef(null);
  const healthCampGalleryRef = useRef(null);
  const iaseonGalleryRef = useRef(null);
  useEffect(() => {
    if (!selectedImage) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setSelectedImage(null);
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImage]);
  const galleryArticleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://www.drsujitkumar.com/gallery"
  },
  "headline": "Gallery – Dr. Sujit Kumar | Orthopedic Surgeon in Hyderabad",
  "description": "View the gallery of orthopedic treatments, surgical procedures, patient care moments, and clinic visuals from Dr. Sujit Kumar’s orthopedic practice in Hyderabad.",
  "image": "https://www.drsujitkumar.com/images/gallery-banner.jpg",
  "author": {
    "@type": "Person",
    "name": "Dr. Sujit Kumar",
    "url": "https://www.drsujitkumar.com/gallery"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Dr. Sujit Kumar Orthopedic Clinic",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.drsujitkumar.com/images/logo.png"
    }
  },
  "datePublished": "2025-01-01",
  "dateModified": "2025-01-01"
};

  // const images = [
  //   {
  //     src: Gallery33,
  //     alt: "Clinic reception and waiting area",
  //     title: "Reception Area",
  //   },
  //   {
  //     src: Gallery34,
  //     alt: "Consultation room",
  //     title: "Consultation Room",
  //   },
  //   {
  //     src: Gallery35,
  //     alt: "Physiotherapy treatment area",
  //     title: "Physiotherapy Area",
  //   },
  //   {
  //     src: Gallery36,
  //     alt: "Examination room with medical equipment",
  //     title: "Examination Room",
  //   },
  //   {
  //     src: Gallery37,
  //     alt: "Rehabilitation gym with exercise equipment",
  //     title: "Rehabilitation Gym",
  //   },
  //   {
  //     src: Gallery38,
  //     alt: "X-ray and imaging room",
  //     title: "Imaging Room",
  //   },
  //   {
  //     src: Gallery39,
  //     alt: "Patient recovery area",
  //     title: "Recovery Area",
  //   },
  //   {
  //     src: Gallery40,
  //     alt: "Orthopedic surgical instruments",
  //     title: "Medical Equipment",
  //   },
  //   {
  //     src: Gallery41,
  //     alt: "Clinic exterior building",
  //     title: "Clinic Exterior",
  //   },
  // ];
  const images = [
    {
      src: TotalKneeReplacement,
      title: "Total Knee Replacement",
    },
    {
      src: Shoulderarthroscopy,
      // alt: "Clinic reception and waiting area",
      title: "Shoulder Arthroscopy Updates at France 2025",
    },
    {
      src: Shoulderarthroscopyprocedure,
      title: "Shoulder Arthroscopy Procedure",
    },
     {
      src: Plastercastingprocedure,
      title: "Plaster Casting Procedure",
    },
    {
      src: Wristarthroscopyprocedure,
      title: "Wrist Arthroscopy Procedure",
    },
    {
      src: Shoulderarthroscopyprocedure2,
      title: "Shoulder Arthroscopy Procedure",
    },
    {
      src: telanganaarthroscopysociety,
      title: "Faculty at Telangana Arthroscopy Society Conference 2025",
    },
    {
      src: hyderabadarthroscopy,
      title: "Faculty at Hyderabad Arthroscopy Conclave 2025",
    },
     {
      src: telanganaorthopaedic,
      title: "Faculty at Telangana Orthopaedic Surgeon Association Conference 2025",
    },
    {
      src: Shoulderarthroscopyprocedure3,
      title: "Shoulder Arthroscopy Procedure",
    },
    {
      src: Tosacon2025,
      title: "Faculty at TOSACON 2025",
    },
    {
      src: Germany2024,
      title: "Visit to Germany to discuss about Regenerative Medicine",
    },
    {
      src: Wristarthroscopyprocedure2,
      title: "Wrist Arthroscopy Procedure",
    },
    {
      src: WithDrlorenzomerlini,
      title: "With Dr.Lorenzo Merlini my mentor,during my fellowship at International Wrist Centre,Paris",
    },
    {
      src: WithDrahlamArnout,
      title: "With Dr.Ahlam Arnout my mentor,during my fellowship at International Wrist Centre,Paris",
    },
    {
      src: Tosacon2024,
      title: "Faculty at TASCON 2024",
    },
    {
      src: carpometarpal,
      title: "1st Carpometarpal Joint Arthroscopy Procedure ",
    },
    {
      src: arthroplastyworkshop,
      title: "1st cmc Joint Arthroplasty Workshop at France 2025",
    },
    {
      src: HandMicrosurgery,
      title: "Hand & Microsurgery",
    },
    {
      src: nephewacademy,
      title: "At Smith n Nephew Academy Singapore",
    },
    {
      src: clinicphoto,
      title: "Clinic Photo",
    },
    {
      src: Opdconsultation,
      title: "OPD Consultation",
    },
    
  ];
  const summitImages = [
    { src: OtsAudience, alt: "Audience attending the Orthopaedic Trauma Summit 2026 in Hyderabad" },
    { src: OtsPresentation, alt: "Dr. Sujit Kumar presenting at the Orthopaedic Trauma Summit 2026" },
    { src: OtsGroup, alt: "Orthopaedic Trauma Summit 2026 faculty and attendees on stage" },
    { src: OtsPoster, alt: "Orthopaedic Trauma Summit 2026 event poster in Hyderabad" },
    { src: OtsFaculty, alt: "Dr. Sujit Kumar with fellow faculty at the Orthopaedic Trauma Summit" },
    { src: OtsFireside, alt: "Friday Fireside Sessions at the Orthopaedic Trauma Summit 2026" },
    { src: OtsSessionFaculty, alt: "Faculty profile graphic for Session 4 at the Orthopaedic Trauma Summit 2026" },
  ];
  const healthCampImages = [
    { src: HealthCamp01, alt: "Team outside the clinic with the DEXA on Wheels mobile health camp van" },
    { src: HealthCamp02, alt: "Dr. Sujit Kumar consulting a patient during the sixth anniversary health camp" },
    { src: HealthCamp03, alt: "A patient receiving a bone density screening at the health camp" },
    { src: HealthCamp04, alt: "Visitors arriving for the sixth anniversary health camp at the clinic" },
    { src: HealthCamp05, alt: "Dr. Sujit Kumar consulting a patient during the health camp" },
    { src: HealthCamp06, alt: "Dr. Sujit Kumar consulting a patient during the health camp" },
    { src: HealthCamp07, alt: "Dr. Sujit Kumar reviewing health information with a visitor" },
    { src: HealthCamp08, alt: "Dr. Sujit Kumar consulting a patient during the health camp" },
    { src: HealthCamp09, alt: "Visitors waiting at the clinic during the health camp" },
    { src: HealthCamp10, alt: "Visitors at the sixth anniversary health camp event" },
  ];
  const iaseonImages = [
    { src: IaseonPhoto01, alt: "Dr. Sujit Kumar and colleagues at the 23rd IASEON 2026 conference in Kolkata" },
    { src: IaseonPhoto02, alt: "Dr. Sujit Kumar speaking at the 23rd IASEON conference" },
    { src: IaseonPhoto03, alt: "Dr. Sujit Kumar with a fellow orthopedic surgeon at IASEON 2026" },
    { src: IaseonPhoto04, alt: "Dr. Sujit Kumar with a colleague at the IASEON conference" },
    { src: IaseonPhoto05, alt: "Dr. Sujit Kumar and colleagues at an IASEON conference gathering" },
    { src: IaseonPhoto06, alt: "Dr. Sujit Kumar at the IASEON 2026 venue in Kolkata" },
    { src: IaseonPhoto07, alt: "Dr. Sujit Kumar's faculty badge for the 23rd IASEON 2026 conference" },
  ];
  return (
    <>
    <SEO
      title="Gallery | Dr. Sujit Kumar – Orthopedic Surgeon in Hyderabad"
      description="Explore the gallery of Dr. Sujit Kumar, showcasing orthopedic procedures, joint replacement surgeries, physiotherapy sessions, patient interactions, and clinical moments at the orthopedic clinic in Hyderabad."
      keywords="Dr Sujit Kumar gallery, orthopedic surgery photos, patient pictures, orthopedic clinic Hyderabad images, joint replacement gallery, physiotherapy images, Hyderabad orthopedic surgeon gallery"
      canonical="https://www.drsujitkumar.com/gallery"
      robots="index, follow"
      author="Dr. Sujit Kumar"
      publisher="Dr. Sujit Kumar Orthopedic Clinic"
      schema={galleryArticleSchema}
    />

    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4 font-playfair">
              Clinic Gallery
            </h1>
            <p className="text-lg text-primary-foreground/90 leading-relaxed">
              Take a virtual tour of our modern facilities and treatment areas
            </p>
          </div>
        </div>
      </section>

      <section className="py-12" aria-labelledby="ots-summit-gallery-title">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 id="ots-summit-gallery-title" className="text-center text-3xl font-bold mb-8 font-playfair">
            Orthopaedic Trauma Summit 2026 | Hyderabad
          </h2>
          <div className="flex items-center gap-3">
            <Button
              type="button"
              variant="default"
              size="icon"
              className="shrink-0 border-2 border-primary bg-primary text-primary-foreground shadow-md hover:bg-primary/85"
              aria-label="Scroll summit images left"
              onClick={() => summitGalleryRef.current?.scrollBy({ left: -340, behavior: 'smooth' })}
            >
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <div
              ref={summitGalleryRef}
              className="scrollbar-hidden flex min-w-0 flex-1 snap-x snap-mandatory gap-6 overflow-x-auto scroll-smooth"
              aria-label="Orthopaedic Trauma Summit 2026 photos"
            >
              {summitImages.map((image) => (
                <button
                  key={image.src}
                  type="button"
                  onClick={() => setSelectedImage(image)}
                  className="w-[min(68vw,320px)] shrink-0 snap-start cursor-zoom-in overflow-hidden rounded-lg bg-muted text-left shadow-md"
                  aria-label={`Enlarge image: ${image.alt}`}
                >
                  <div className="aspect-[3/3] overflow-hidden">
                    <img src={image.src} alt={image.alt} loading="lazy" className="h-full w-full object-contain" />
                  </div>
                </button>
              ))}
            </div>
            <Button
              type="button"
              variant="default"
              size="icon"
              className="shrink-0 border-2 border-primary bg-primary text-primary-foreground shadow-md hover:bg-primary/85"
              aria-label="Scroll summit images right"
              onClick={() => summitGalleryRef.current?.scrollBy({ left: 340, behavior: 'smooth' })}
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      <section className="pb-12" aria-labelledby="health-camp-gallery-title">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 id="health-camp-gallery-title" className="text-center text-3xl font-bold mb-8 font-playfair">
            6th Anniversary Health Camp
          </h2>
          <div className="flex items-center gap-3">
            <Button
              type="button"
              variant="default"
              size="icon"
              className="shrink-0 border-2 border-primary bg-primary text-primary-foreground shadow-md hover:bg-primary/85"
              aria-label="Scroll health camp images left"
              onClick={() => healthCampGalleryRef.current?.scrollBy({ left: -340, behavior: 'smooth' })}
            >
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <div
              ref={healthCampGalleryRef}
              className="scrollbar-hidden flex min-w-0 flex-1 snap-x snap-mandatory gap-6 overflow-x-auto scroll-smooth"
              aria-label="6th Anniversary Health Camp photos"
            >
              {healthCampImages.map((image) => (
                <button
                  key={image.src}
                  type="button"
                  onClick={() => setSelectedImage(image)}
                  className="w-[min(68vw,320px)] shrink-0 snap-start cursor-zoom-in overflow-hidden rounded-lg bg-muted text-left shadow-md"
                  aria-label={`Enlarge image: ${image.alt}`}
                >
                  <div className="aspect-[3/3] overflow-hidden">
                    <img src={image.src} alt={image.alt} loading="lazy" className="h-full w-full object-contain" />
                  </div>
                </button>
              ))}
            </div>
            <Button
              type="button"
              variant="default"
              size="icon"
              className="shrink-0 border-2 border-primary bg-primary text-primary-foreground shadow-md hover:bg-primary/85"
              aria-label="Scroll health camp images right"
              onClick={() => healthCampGalleryRef.current?.scrollBy({ left: 340, behavior: 'smooth' })}
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      <section className="pb-12" aria-labelledby="iaseon-gallery-title">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 id="iaseon-gallery-title" className="text-center text-3xl font-bold mb-8 font-playfair">
            23rd IASEON 2026 | Kolkata
          </h2>
          <div className="flex items-center gap-3">
            <Button
              type="button"
              variant="default"
              size="icon"
              className="shrink-0 border-2 border-primary bg-primary text-primary-foreground shadow-md hover:bg-primary/85"
              aria-label="Scroll IASEON images left"
              onClick={() => iaseonGalleryRef.current?.scrollBy({ left: -340, behavior: 'smooth' })}
            >
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <div
              ref={iaseonGalleryRef}
              className="scrollbar-hidden flex min-w-0 flex-1 snap-x snap-mandatory gap-6 overflow-x-auto scroll-smooth"
              aria-label="23rd IASEON 2026 photos"
            >
              {iaseonImages.map((image) => (
                <button
                  key={image.src}
                  type="button"
                  onClick={() => setSelectedImage(image)}
                  className="w-[min(68vw,320px)] shrink-0 snap-start cursor-zoom-in overflow-hidden rounded-lg bg-muted text-left shadow-md"
                  aria-label={`Enlarge image: ${image.alt}`}
                >
                  <div className="aspect-[3/3] overflow-hidden">
                    <img src={image.src} alt={image.alt} loading="lazy" className="h-full w-full object-contain" />
                  </div>
                </button>
              ))}
            </div>
            <Button
              type="button"
              variant="default"
              size="icon"
              className="shrink-0 border-2 border-primary bg-primary text-primary-foreground shadow-md hover:bg-primary/85"
              aria-label="Scroll IASEON images right"
              onClick={() => iaseonGalleryRef.current?.scrollBy({ left: 340, behavior: 'smooth' })}
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          {/* <div className="text-center mb-12">
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Our clinic is equipped with modern facilities and equipment to provide you with the best possible care in
              a comfortable environment.
            </p>
          </div> */}

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {images.map((image, index) => (
              <button
                key={index}
                type="button"
                onClick={() => setSelectedImage({ ...image, alt: image.alt || image.title })}
                className="group relative w-full cursor-zoom-in overflow-hidden rounded-lg text-left shadow-md transition-shadow hover:shadow-xl"
                aria-label={`Enlarge image: ${image.alt || image.title}`}
              >
                <div className="aspect-[3/3] overflow-hidden">
                  <img
                    src={image.src}
                    alt={image.alt || image.title}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white font-semibold text-lg">{image.title}</h3>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4 font-playfair">Visit Our Clinic</h2>
          <p className="text-lg mb-8 text-muted-foreground max-w-2xl mx-auto">
            Experience our modern facilities and expert care in person. Book an appointment today.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Button size="lg" asChild>
              <Link to="/book-appointment">Book Appointment</Link>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <Link to="/contact">Get Directions</Link>
            </Button>
          </div>
        </div>
      </section>

      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 sm:p-8"
          role="dialog"
          aria-modal="true"
          aria-label={selectedImage.alt}
          onClick={() => setSelectedImage(null)}
        >
          <Button
            type="button"
            variant="default"
            size="icon"
            className="absolute right-4 top-4 z-10 bg-white text-black hover:bg-white/85"
            aria-label="Close enlarged image"
            onClick={() => setSelectedImage(null)}
          >
            <X className="h-5 w-5" />
          </Button>
          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="max-h-[90vh] max-w-[95vw] rounded-lg object-contain"
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </div>
    </>
  );
}
